'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _changeCurrentBlockType = require('../../customRichUtils/changeCurrentBlockType');

var _changeCurrentBlockType2 = _interopRequireDefault(_changeCurrentBlockType);

var _matchBlockTypeMarkdown = require('./matchBlockTypeMarkdown');

var _matchBlockTypeMarkdown2 = _interopRequireDefault(_matchBlockTypeMarkdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
exports.default = function (editorState, character) {
    var currentSelection = editorState.getSelection();
    var key = currentSelection.getStartKey();
    var text = editorState.getCurrentContent().getBlockForKey(key).getText();
    var position = currentSelection.getAnchorOffset();
    var lineAfterCharacter = text.slice(position);
    var line = [text.slice(0, position), character, lineAfterCharacter].join('');

    var newBlockType = (0, _matchBlockTypeMarkdown2.default)(line);

    return (0, _changeCurrentBlockType2.default)(editorState, newBlockType, lineAfterCharacter);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/markdownSupport/handleBlockType.js
// module id = 1735
// module chunks = 0